<script lang="ts">
import { widgetOptions } from '@/modules/options'

import BrandingLink from './WidgetBrandingLink.svelte'
import BrandingText from './WidgetBrandingText.svelte'

const { customBrandingLink, customBrandingText } = widgetOptions.getOptions()
</script>

{#if customBrandingLink}
	<BrandingLink url={customBrandingLink}>
		<BrandingText>{customBrandingText}</BrandingText>
	</BrandingLink>
{:else}
	<BrandingText>{customBrandingText}</BrandingText>
{/if}
